export default __webpack_public_path__ + "static/media/element.460008a2.png";